export default __webpack_public_path__ + "static/media/heart.325294d9.svg";